var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 0.0999985C5.70002 0.0999985 0.700073 5.1 0.700073 11.3C0.700073 17.5 5.70002 22.5 11.9 22.5C18.1 22.5 23.1 17.5 23.1 11.3C23.2 5.2 18.1 0.0999985 11.9 0.0999985ZM11.9 2.9C13.7 2.9 15.1 4.3 15.1 6.1C15.1 7.9 13.7 9.3 11.9 9.3C10.1 9.3 8.70007 7.9 8.70007 6.1C8.70007 4.3 10.1 2.9 11.9 2.9ZM16.3 17.9H7.5C6.6 17.9 5.90002 17.2 5.90002 16.3C5.90002 13 8.60005 10.4 11.8 10.4C15.1 10.4 17.7001 13.1 17.7001 16.3C17.9001 17.2 17.2 17.9 16.3 17.9Z",
    fill: "#FAEDD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.d6e78aa535727e07fe55d6d38313179a.svg";
export { ForwardRef as ReactComponent };